module.exports = __webpack_public_path__ + "img/description4.e45f8268.jpg";